export const DateTypes = {
  LIMITED: "limited",
  UNLIMITED: "unlimited",
} as const;

export type DateType = typeof DateTypes[keyof typeof DateTypes];
